import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function saveNote(note, studentId, method) {
  const body = {
    value: parseInt(note.value),
    id_module: note.module,
    id_student: studentId,
  };

  const url = `${BASE_URL}/api/notes${note.id ? `/${note.id}` : ""}`;

  return axiosInstance({
    method,
    url,
    data: body,
    headers: {
      "Content-Type": "application/json",
    },
  });
}
